import { useEffect, useState } from "react";
import { Info, CalendarCheck } from "lucide-react";
import { useLang } from "@/i18n";
import { submitRequest } from "@/config";
import { Field, Input, Textarea, Select, Gdpr, Honeypot, SuccessBox, SubmitBtn, useFormState, todayISO } from "@/components/FormBits";
import { toast } from "sonner";

export default function Afspraak() {
  const { t } = useLang();
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, set] = useFormState({ service: "", vehicle: "", date: "", slot: "", name: "", phone: "", email: "", remarks: "", website: "", gdpr: false });

  useEffect(() => {
    window.scrollTo(0, 0);
    set("service")({ target: { value: t("appt.services")[0] } });
    set("slot")({ target: { value: t("appt.slots")[0] } });
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await submitRequest("appointment", data); setDone(true); window.scrollTo(0, 0); }
    catch (err) { toast.error(err.message); }
    setLoading(false);
  };

  return (
    <div className="container-x py-14 max-w-3xl" data-testid="afspraak-page">
      <p className="overline-red">Milano Worx</p>
      <h1 className="mt-2 text-4xl sm:text-5xl font-extrabold uppercase tracking-tight text-white">{t("appt.title")}</h1>
      <p className="mt-3 text-zinc-400">{t("appt.sub")}</p>

      <div className="mt-6 flex items-start gap-3 card-dark border-[#D97706]/40 p-4" data-testid="appointment-notice">
        <Info size={18} className="text-[#D97706] shrink-0 mt-0.5" />
        <p className="text-sm text-zinc-300">{t("appt.notice")}</p>
      </div>

      {done ? (
        <div className="mt-8"><SuccessBox message={t("appt.success")} testid="appointment-success" /></div>
      ) : (
        <form onSubmit={submit} className="mt-8 card-dark p-6 grid gap-4" data-testid="appointment-form">
          <Honeypot value={data.website} onChange={set("website")} />
          <div className="grid sm:grid-cols-2 gap-4">
            <Field label={t("form.service")} required><Select options={t("appt.services")} value={data.service} onChange={set("service")} data-testid="a-service" /></Field>
            <Field label={t("rental.chosen")} required><Input required placeholder="VW Golf 1.5 TSI (2020)" value={data.vehicle} onChange={set("vehicle")} data-testid="a-vehicle" /></Field>
            <Field label={t("form.date")} required><Input required type="date" min={todayISO()} value={data.date} onChange={set("date")} data-testid="a-date" /></Field>
            <Field label={t("form.slot")} required><Select options={t("appt.slots")} value={data.slot} onChange={set("slot")} data-testid="a-slot" /></Field>
            <Field label={t("form.name")} required><Input required value={data.name} onChange={set("name")} data-testid="a-name" /></Field>
            <Field label={t("form.phone")} required><Input required type="tel" value={data.phone} onChange={set("phone")} data-testid="a-phone" /></Field>
            <Field label={t("form.email")} required><Input required type="email" value={data.email} onChange={set("email")} data-testid="a-email" /></Field>
            <Field label={t("form.remarks")}><Input value={data.remarks} onChange={set("remarks")} data-testid="a-remarks" /></Field>
          </div>
          <Gdpr checked={data.gdpr} onChange={(v) => set("gdpr")({ target: { value: v } })} />
          <SubmitBtn loading={loading} label={t("appt.send")} testid="a-submit" />
          <p className="text-xs text-zinc-500 text-center" data-testid="deposit-note">{t("form.depositNote")}</p>
        </form>
      )}
    </div>
  );
}
